import React, { useEffect, useMemo } from 'react';

import { Grid } from '@material-ui/core';

import { ENDPOINTS } from '../../consts/endpoints';
import { usePartner } from '../../context/PartnerContext';

/**
 *
 * @Footer Componente para exibicao de um Footerfixo da aplicação
 * @CriadoEm 24/01/2022
 */

export default function Footer() {
  const [iframeHeight, setIframeHeight] = React.useState('100%');
  const partner = usePartner();
  const footerUrl = useMemo(
    () => `${ENDPOINTS.IFRAME_FOOTER}?partner_id=${partner.id}`,
    [partner],
  );

  useEffect(() => {
    const eventHandler = (e) => {
      if (e.origin !== ENDPOINTS.IFRAME_FOOTER) return;
      setIframeHeight(`${e.data}px`);
    };
    window.addEventListener('message', eventHandler);
    return () => window.removeEventListener('message', eventHandler);
  }, []);

  return (
    <Grid container>
      <iframe
        id="iframe"
        title="footer"
        src={footerUrl}
        width="100%"
        style={{ border: '0', height: iframeHeight }}
      />
    </Grid>
  );
}
